export const createTagPayload = (tag, icon, tagType, type, description = tag) => ({
    description,
    displayName: tag,
    tag,
    tagType,
    topicIcon: icon,
    ...(type ? {type} : {})
})